import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import logo from "../../base/assets/images/main_logo.svg";
import BackButton from "../../base/features/micro/BackButton";
import { confirm, login } from "./services";
import { FiChevronRight } from "react-icons/fi";
import Swal from "sweetalert2";
import fix_numbers from "../../base/utils/fix_numbers";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      phone: "",
      loginMode: true,
      loginToken: "",
      expire_time: "",
      code: "",
      pending: false,
      err406: false,
      redirect: false,
    };
    this.codeInput = React.createRef();
  }

  submitLogin() {
    this.setState({ pending: true });
    login(fix_numbers.fixNumbers(this.state.phone)).then((loginRes) => {
      if (loginRes && loginRes.status === 200)
        this.setState(
          {
            loginToken: loginRes.data.token,
            expire_time: loginRes.data.expire_time,
            loginMode: false,
            pending: false,
          },
          () => {
            var timer = setInterval(() => {
              this.state.expire_time > 0
                ? this.setState({
                    expire_time: Number(this.state.expire_time) - 1,
                  })
                : clearInterval(timer);
            }, 1000);
          }
        );
      else {
        this.setState({ pending: false });
        Swal.fire({
          text: "شماره نامعتبر است",
          icon: "error",
          confirmButtonText: "تایید",
        });
      }
    });
  }
  submitConfirm() {
    this.setState({ pending: true, err406: false });
    confirm(
      fix_numbers.fixNumbers(this.state.code),
      this.state.loginToken
    ).then((res) => {
      if (res.response && res.response.status && res.response.status === 406) {
        this.setState({ err406: true });
        this.codeInput.current.classList.add("border-danger", "text-danger");
      }
      if (res && res.status === 200) {
        this.setToken(res.data.access_token, res.data.next);
        this.setState({ err406: false });
      }
      this.setState({ pending: false });
    });
  }
  setToken(token, next) {
    Promise.resolve().then((v) =>
      localStorage.setItem(
        `${window.location.hostname}_token`,
        "GityToken " + token
      )
    );
    if (next.action === 1) {
      window.location.href = "/editProfile";
    } else {
      if (window.history.length > 2) {
        window.history.back();
      } else {
        window.location.href = "/";
      }
    }
  }
  render() {
    if (this.state.redirect) {
      return <Redirect push to={"/"} />;
    }
    return (
      <div className="container-fluid px-0">
        {this.state.loginMode ? (
          <div className="row mx-0 px-4" style={{ marginTop: "28%" }} dir="rtl">
            <header
              className="row w-auto mx-0 px-3 py-2-3 position-fixed bg-white shadow-sm"
              style={{ top: "0", right: "0", left: "0" }}
            >
              <div className="col-auto align-self-center px-0">
                <FiChevronRight
                  size="26"
                  className=""
                  onClick={() =>
                    window.history.length > 2
                      ? window.history.go(-2)
                      : this.setState({ redirect: true })
                  }
                />
              </div>

              <div className="col align-self-center text-center px-0">
                <h1 className="fs-5 fw-bold mb-0">ورود</h1>
              </div>
            </header>
            <div className="col-12 text-center">
              <div style={{ marginBottom: "18%" }}>
                <img src={logo} width="75%" className="" />
              </div>
              <input
                placeholder="شماره همراه شما"
                style={{ height: "50px" }}
                type="tel"
                dir="rtl"
                onFocus={(e) => {
                  e.target.dir = "ltr";
                  e.target.placeholder = "";
                }}
                maxLength="11"
                value={this.state.phone}
                onChange={(e) => this.setState({ phone: e.target.value })}
                className="rounded14 w-100 form-control"
              />
              <p className="fw-bold fs-6 text-end my-3">
                شماره تلفن همراه خود را وارد کنید.بعد از وارد کردن شماره کد چهار
                رقمی را به شما ارسال می کنیم.
              </p>
              <button
                disabled={
                  !this.state.phone ||
                  !this.state.phone.startsWith("09") ||
                  this.state.phone.length !== 11 ||
                  this.state.pending
                }
                className="w-100 btn rounded28 mt-2 py-2-3 bg-color-main text-white"
                onClick={() => this.submitLogin()}
              >
                {this.state.pending ? (
                  <span
                    className="spinner-border spinner-border-sm text-white"
                    style={{ verticalAlign: "middle" }}
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  <b>ورود</b>
                )}
              </button>
              <Link to="/terms-of-use">
                <div className="text-center color-main small mt-3">
                  قوانین و مقررات
                </div>
              </Link>
            </div>
          </div>
        ) : (
          <div>
            <div className="row mx-0" dir="rtl">
              <div className="col-12 px-4 py-3 shadow-sm">
                <BackButton path={"/login"} />
              </div>
            </div>
            <div className="row mx-0" dir="rtl">
              <div className="col-12 mt-4 text-center px-5">
                <h6 className="card-title my-3 text-center">
                  کد ۴ رقمی ارسال شده به
                  <span className="color-main">
                    {" " + this.state.phone + " "}
                  </span>
                  را وارد کنید
                </h6>
                <p className="fs-2 fw-bolder">
                  {this.state.expire_time === 0 ? (
                    <button
                      className="btn fs-6 color-main"
                      onClick={() => this.submitLogin()}
                    >
                      ارسال دوباره کد
                    </button>
                  ) : (
                    ~~(this.state.expire_time / 60) +
                    ":" +
                    (this.state.expire_time % 60 < 10
                      ? "0" + (this.state.expire_time % 60)
                      : this.state.expire_time % 60)
                  )}
                </p>
                <input
                  ref={this.codeInput}
                  className="form-control mb-2 text-center rounded14 w-100 bg-gray rounded12 fs-3 mt-4"
                  autoFocus={true}
                  type="tel"
                  dir="ltr"
                  placeholder=" -  -  -  - "
                  onChange={(e) =>
                    this.setState(
                      { code: e.target.value },
                      () => this.state.code.length === 4 && this.submitConfirm()
                    )
                  }
                  maxLength="4"
                  value={this.state.code}
                />
                {this.state.err406 && (
                  <p className="text-danger fs-6 text-center py-2">
                    کد وارد شده اشتباه است
                  </p>
                )}
                <button
                  className="btn py-2-3 bg-color-main fs-6 text-white w-100 rounded28 border-0 color-white btn-lg mt-3 mb-3"
                  type="button"
                  disabled={this.state.pending || this.state.code.length !== 4}
                  onClick={() => this.submitConfirm()}
                >
                  {this.state.pending ? (
                    <span
                      className="spinner-border spinner-border-sm text-white"
                      role="status"
                      style={{ verticalAlign: "middle" }}
                      aria-hidden="true"
                    />
                  ) : (
                    <b>تایید</b>
                  )}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default Login;
